// Shared admin design tokens (sidebar-matched)

export const ADMIN_COLORS = {
  sidebarDark: "#0f172a",
  sidebarDark2: "#111827",
  sidebarAccent: "#1e293b",
  pageBg: "#f1f5f9",
  surface: "#ffffff",
  surfaceMuted: "#f8fafc",
  border: "#e2e8f0",
  borderLight: "#f1f5f9",
  textPrimary: "#0f172a",
  textSecondary: "#64748b",
  textMuted: "#94a3b8",
  textOnDark: "#f8fafc",
};

export const adminSectionHeaderProps = {
  style: {
    background: `linear-gradient(180deg, ${ADMIN_COLORS.sidebarDark} 0%, ${ADMIN_COLORS.sidebarDark2} 100%)`,
    color: ADMIN_COLORS.textOnDark,
    padding: "12px 16px",
    borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
  },
  titleTypographyProps: {
    style: {
      fontSize: "0.95rem",
      fontWeight: 700,
      color: ADMIN_COLORS.textOnDark,
    },
  },
  subheaderTypographyProps: {
    style: {
      fontSize: "0.72rem",
      color: ADMIN_COLORS.textMuted,
    },
  },
};

export const adminCardStyle = {
  borderRadius: 12,
  border: `1px solid ${ADMIN_COLORS.border}`,
  boxShadow: "none",
  overflow: "hidden",
};
